import { LanguageType } from '@nx-smartmonkey/shared/domain';

import * as routing from '../../constants/Routing';

type Docs =
  | `clients`
  | `createStops`
  | `createStopsVideo`
  | `stopsFromFileV2`
  | `vehicles`
  | `createVehicles`
  | `customersWhiteLabel`
  | `communicationCustomers`
  | `communicationEmails`
  | `communicationSMS`
  | `tasks`
  | `geoFences`
  | `plan`
  | `SMSummary`
  | `driversPOD`
  | `settingsMembers`
  | `settingsFields`
  | `settingsSurveys`
  | `developers`
  | `customDomain`
  | `supervisors`
  | `settingsOptimizer`
  | `createCustomFields`
  | `securityPin`
  | `driverApp`;

const docs: Record<Docs, Record<LanguageType, string>> = {
  clients: {
    en: `en/articles/5170088`,
    es: `es/articles/5170088`,
    pt: `pt/articles/5170088`,
    ca: `pt/articles/5170088`,
    de: `pt/articles/5170088`,
    fr: `pt/articles/5170088`,
  },
  createStops: {
    en: `en/articles/5204294`,
    es: `es/articles/5204294`,
    pt: `pt/articles/5204294`,
    ca: `pt/articles/5204294`,
    de: `pt/articles/5204294`,
    fr: `pt/articles/5204294`,
  },
  createStopsVideo: {
    // Los links son distintos porque no existe el video de 5145681 para los otros idiomas
    en: `en/articles/5145681`,
    es: `es/articles/5204294`,
    pt: `pt/articles/5204294`,
    ca: `pt/articles/5204294`,
    de: `pt/articles/5204294`,
    fr: `pt/articles/5204294`,
  },
  stopsFromFileV2: {
    en: `en/articles/9305784`,
    es: `es/articles/9305784`,
    pt: `pt/articles/9305784`,
    ca: `pt/articles/9305784`,
    de: `pt/articles/9305784`,
    fr: `pt/articles/9305784`,
  },
  vehicles: {
    en: `en/articles/5951015`,
    es: `es/articles/5951015`,
    pt: `pt/articles/5951015`,
    ca: `pt/articles/5951015`,
    de: `pt/articles/5951015`,
    fr: `pt/articles/5951015`,
  },
  createVehicles: {
    en: `en/articles/5084926`,
    es: `es/articles/5084926`,
    pt: `pt/articles/5084926`,
    ca: `pt/articles/5084926`,
    de: `pt/articles/5084926`,
    fr: `pt/articles/5084926`,
  },
  customersWhiteLabel: {
    en: `en/articles/7930702`,
    es: `es/articles/7930702`,
    pt: `pt/articles/7930702`,
    ca: `pt/articles/7930702`,
    de: `pt/articles/7930702`,
    fr: `pt/articles/7930702`,
  },
  communicationCustomers: {
    en: `en/articles/6705351`,
    es: `es/articles/6705351`,
    pt: `pt/articles/6705351`,
    ca: `pt/articles/6705351`,
    de: `pt/articles/6705351`,
    fr: `pt/articles/6705351`,
  },
  communicationEmails: {
    en: `en/articles/5162585`,
    es: `es/articles/5162585`,
    pt: `pt/articles/5162585`,
    ca: `pt/articles/5162585`,
    de: `pt/articles/5162585`,
    fr: `pt/articles/5162585`,
  },
  communicationSMS: {
    en: `en/articles/5981858`,
    es: `es/articles/5981858`,
    pt: `pt/articles/5981858`,
    ca: `pt/articles/5981858`,
    de: `pt/articles/5981858`,
    fr: `pt/articles/5981858`,
  },
  tasks: {
    en: `en/articles/5588913`,
    es: `es/articles/5588913`,
    pt: `pt/articles/5588913`,
    ca: `pt/articles/5588913`,
    de: `pt/articles/5588913`,
    fr: `pt/articles/5588913`,
  },
  geoFences: {
    en: `en/articles/5728068`,
    es: `es/articles/5728068`,
    pt: `pt/articles/5728068`,
    ca: `pt/articles/5728068`,
    de: `pt/articles/5728068`,
    fr: `pt/articles/5728068`,
  },
  plan: {
    en: `en/articles/5161252`,
    es: `es/articles/5161252`,
    pt: `pt/articles/5161252`,
    ca: `pt/articles/5161252`,
    de: `pt/articles/5161252`,
    fr: `pt/articles/5161252`,
  },
  SMSummary: {
    en: `en/articles/5227876`,
    es: `es/articles/5227876`,
    pt: `pt/articles/5227876`,
    ca: `pt/articles/5227876`,
    de: `pt/articles/5227876`,
    fr: `pt/articles/5227876`,
  },
  driversPOD: {
    en: `en/articles/6563466`,
    es: `es/articles/6563466`,
    pt: `pt/articles/6563466`,
    ca: `pt/articles/6563466`,
    de: `pt/articles/6563466`,
    fr: `pt/articles/6563466`,
  },
  settingsMembers: {
    en: `en/articles/5169576`,
    es: `es/articles/5169576`,
    pt: `pt/articles/5169576`,
    ca: `pt/articles/5169576`,
    de: `pt/articles/5169576`,
    fr: `pt/articles/5169576`,
  },
  settingsFields: {
    en: `en/articles/5162189`,
    es: `es/articles/5162189`,
    pt: `pt/articles/5162189`,
    ca: `pt/articles/5162189`,
    de: `pt/articles/5162189`,
    fr: `pt/articles/5162189`,
  },
  settingsSurveys: {
    en: `en/collections/2821400`,
    es: `es/collections/2821400`,
    pt: `pt/collections/2821400`,
    ca: `pt/collections/2821400`,
    de: `pt/collections/2821400`,
    fr: `pt/collections/2821400`,
  },
  developers: {
    en: `en/collections/2821410`,
    es: `es/collections/2821410`,
    pt: `pt/collections/2821410`,
    ca: `pt/collections/2821410`,
    de: `pt/collections/2821410`,
    fr: `pt/collections/2821410`,
  },
  customDomain: {
    es: `es/articles/8347504`,
    en: `en/articles/8347504`,
    pt: `pt/articles/8347504`,
    ca: `pt/articles/8347504`,
    de: `pt/articles/8347504`,
    fr: `pt/articles/8347504`,
  },
  supervisors: {
    es: `es/articles/8349046`,
    en: `en/articles/8349046`,
    pt: `pt/articles/8349046`,
    ca: `pt/articles/8349046`,
    de: `pt/articles/8349046`,
    fr: `pt/articles/8349046`,
  },
  settingsOptimizer: {
    es: `es/articles/7906948`,
    en: `en/articles/7906948`,
    pt: `pt/articles/7906948`,
    ca: `pt/articles/7906948`,
    de: `pt/articles/7906948`,
    fr: `pt/articles/7906948`,
  },
  createCustomFields: {
    es: `es/articles/5848642`,
    en: `en/articles/5848642`,
    pt: `pt/articles/5848642`,
    ca: `pt/articles/5848642`,
    de: `pt/articles/5848642`,
    fr: `pt/articles/5848642`,
  },
  securityPin: {
    es: `es/articles/7911845`,
    en: `en/articles/7911845`,
    pt: `pt/articles/7911845`,
    ca: `pt/articles/7911845`,
    de: `pt/articles/7911845`,
    fr: `pt/articles/7911845`,
  },
  driverApp: {
    es: `es/articles/5165466`,
    en: `en/articles/5165466`,
    pt: `pt/articles/5165466`,
    ca: `pt/articles/5165466`,
    de: `pt/articles/5165466`,
    fr: `pt/articles/5165466`,
  },
};

export const useRetrieveSupportDocs = () => {
  const retrieveDoc = ({ supportPage, language = `en` }: { supportPage?: Docs; language?: LanguageType }): string => {
    // THIS IS TEMPORAL. Portuguese pages are not available for the moment.
    const lang = language === `pt` ? `en` : language;

    if (!supportPage) {
      return `${routing.EXTERNAL.DOCS}${lang}/`;
    }

    return `${routing.EXTERNAL.DOCS}${docs[supportPage][lang]}`;
  };

  return {
    retrieveDoc,
  };
};
